var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAllDocumentsActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63113 3H5.03471C4.46326 3 4 3.45594 4 4.01837V11.2519C4 11.8144 4.46326 12.2703 5.03471 12.2703H9.63113C10.2026 12.2703 10.6658 11.8144 10.6658 11.2519V4.01837C10.6658 3.45594 10.2026 3 9.63113 3Z",
    fill: "#4E4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61881 3.53358H5.01774C4.73138 3.53358 4.49925 3.76993 4.49925 4.06148V11.1171C4.49925 11.4086 4.73138 11.645 5.01774 11.645H9.61881C9.90516 11.645 10.1373 11.4086 10.1373 11.1171V4.06148C10.1373 3.76993 9.90516 3.53358 9.61881 3.53358Z",
    fill: "url(#paint0_linear_3708_15287)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.07166V11.3062C12 12.5609 11.6801 13.71 10.1214 13.71H7.43939C7.02249 13.7013 6.62331 13.537 6.37782 13.0565C6.34347 12.9893 6.34645 13.0034 6.41216 13.0034H10.1235C11.0176 13.0366 11.4507 12.4458 11.4715 11.2977C11.4715 9.02553 11.4715 7.16317 11.4715 4.89096C11.4715 4.84717 11.4701 4.85629 11.4958 4.88737C11.6965 5.13022 12 5.50406 12 6.07166Z",
    fill: "#4E4E4E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48862 5.09284C9.48862 4.90915 9.38138 4.76025 9.24909 4.76025H5.41669C5.2844 4.76025 5.17716 4.90915 5.17716 5.09284C5.17716 5.27653 5.2844 5.42543 5.41669 5.42543H9.24909C9.38138 5.42543 9.48862 5.27653 9.48862 5.09284Z",
    fill: "#4E4E4E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0202 6.75578C9.0202 6.5721 8.91297 6.4232 8.78068 6.4232H5.41669C5.2844 6.4232 5.17716 6.5721 5.17716 6.75578C5.17716 6.93947 5.2844 7.08837 5.41669 7.08837H8.78068C8.91297 7.08837 9.0202 6.93947 9.0202 6.75578Z",
    fill: "#4E4E4E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1967 8.41095C8.1967 8.22726 8.08946 8.07836 7.95717 8.07836H5.41669C5.2844 8.07836 5.17716 8.22726 5.17716 8.41095C5.17716 8.59464 5.2844 8.74354 5.41669 8.74354H7.95717C8.08946 8.74354 8.1967 8.59464 8.1967 8.41095Z",
    fill: "#4E4E4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16921 10.0739C7.16921 9.8902 7.06197 9.7413 6.92968 9.7413H5.41669C5.2844 9.7413 5.17716 9.8902 5.17716 10.0739C5.17716 10.2576 5.2844 10.4065 5.41669 10.4065H6.92968C7.06197 10.4065 7.16921 10.2576 7.16921 10.0739Z",
    fill: "#4E4E4E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_15287",
    x1: 11.8432,
    y1: 13.5467,
    x2: 3.11313,
    y2: 3.80688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14F27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllDocumentsActiveIcon);
export default __webpack_public_path__ + "static/media/selectAllDocumentsActiveIcon.430e7c43a1d32fd462d49e19c27f3385.svg";
export { ForwardRef as ReactComponent };